import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_AMPLITUDE_SESSION_REPLAY_CONFIG = defineFcm('amplitude_session_replay_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				sampleRate: {
					type: 'number',
					normalizer: (v: number) => {
						if (v < 0 || v > 1) {
							throw new Error('Sample rate must be between 0 and 1');
						}
						return v;
					},
				},
				routes: {
					type: 'record',
					shape: {
						type: 'boolean',
					},
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		sampleRate: 0,
		routes: {},
	})
	.toConfig();
